<template>
  <div class="d-flex flex-column view-wrapper">
    
    <v-card class="elevation-1 rounded-0 mb-1 flex-shrink-0" color="amber darken-2">
      <v-card-text class="pa-2 d-flex justify-space-between align-center">
        <div>
          <div class="text-subtitle-1 font-weight-bold white--text">
            {{ tituloTabela }}
          </div>
          <div v-if="periodoFormatado" class="caption white--text" style="opacity: 0.9;">
            {{ periodoFormatado }}
          </div>
        </div>
        
        <v-chip small color="white" outlined class="font-weight-medium">
          {{ items.length }} {{ tipoFiltro === 'convertidos' ? 'Convertidos' : (tipoFiltro === 'a-converter' ? 'A Converter' : 'Orçamentos') }}
        </v-chip>
      </v-card-text>
    </v-card>

    <div class="content-container flex-grow-1 elevation-1 white" style="position: relative; min-height: 0;">
      
      <div v-if="loading" class="d-flex justify-center align-center fill-height">
        <v-progress-circular indeterminate color="amber darken-2"></v-progress-circular>
      </div>

      <div v-else-if="items.length === 0" class="d-flex justify-center align-center fill-height grey--text">
        <div class="text-center">
          <v-icon size="48" color="grey lighten-2">mdi-file-document-outline</v-icon>
          <p class="mt-2">Nenhum orçamento encontrado.</p>
        </div>
      </div>

      <simplebar
        v-else
        :auto-hide="false"
        class="table-scroll-container"
        style="height: 100%; max-width: 100%;"
      >
        <table class="table-custom" :class="{ 'tabela-convertidos': tipoFiltro === 'convertidos' }">
          <colgroup v-if="tipoFiltro === 'convertidos'">
            <col style="width: 80px; min-width: 80px;" />
            <col style="width: 85px; min-width: 85px;" />
            <col style="width: 80px; min-width: 80px;" />
            <col style="width: 75px; min-width: 75px;" />
            <col style="width: auto; min-width: 150px;" />
            <col style="width: 95px; min-width: 95px;" />
          </colgroup>
          <colgroup v-else>
            <col style="width: 90px; min-width: 90px;" />
            <col style="width: 85px; min-width: 85px;" />
            <col style="width: auto; min-width: 180px;" />
            <col style="width: 110px; min-width: 110px;" />
          </colgroup>
          <thead class="table-header sticky-header">
            <tr v-if="tipoFiltro === 'convertidos'">
              <th class="text-center pl-2">Data</th>
              <th class="text-center pl-1">Data Conv.</th>
              <th class="text-center">Orçamento</th>
              <th class="text-center">Pedido</th>
              <th class="text-left pl-2">Cliente</th>
              <th class="text-right pr-3">Valor</th>
            </tr>
            <tr v-else>
              <th class="text-center pl-2">Data</th>
              <th class="text-center">Orçamento</th>
              <th class="text-left pl-2">Cliente</th>
              <th class="text-right pr-3">Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="item.id || index"
              class="table-row"
              :class="{ 'linha-alternada': index % 2 !== 0 }"
            >
              <td class="text-center pl-2">
                {{ formatarData(item.data) }}
              </td>

              <td v-if="tipoFiltro === 'convertidos'" class="text-center pl-1 font-weight-medium amber--text text--darken-3">
                {{ formatarData(item.dataconversao) }}
              </td>

              <td class="text-center font-weight-medium">
                {{ item.numeroOrcamento }}
              </td>

              <td v-if="tipoFiltro === 'convertidos'" class="text-center font-weight-medium">
                {{ item.idpedidoback || '-' }}
              </td>

              <td class="text-left pl-2 text-truncate" :style="tipoFiltro === 'convertidos' ? 'max-width: 150px;' : 'max-width: 220px;'" :title="item.nomeCliente">
                {{ item.nomeCliente }}
              </td>

              <td class="text-right pr-3 font-weight-bold">
                {{ formatarValor(item.valor) }}
              </td>
            </tr>
          </tbody>
        </table>
      </simplebar>
    </div>

    <v-card class="elevation-4 rounded-0 flex-shrink-0 grey lighten-4">
      <v-card-text class="pa-2">
        <v-row v-if="tipoFiltro === 'convertidos'" no-gutters justify="space-between" align="center">
          <v-col cols="6" class="text-center">
            <div class="caption grey--text text--darken-2">Qtd. Convertidos</div>
            <div class="font-weight-bold amber--text text--darken-3 body-2">
              {{ items.length }}
            </div>
          </v-col>
          <v-col cols="6" class="text-center border-left">
            <div class="caption grey--text text--darken-2">Total Convertido</div>
            <div class="font-weight-black green--text text--darken-3 body-2">
              {{ formatarValor(totalValor) }}
            </div>
          </v-col>
        </v-row>
        <v-row v-else-if="tipoFiltro === 'a-converter'" no-gutters justify="space-between" align="center">
          <v-col cols="6" class="text-center">
            <div class="caption grey--text text--darken-2">Qtd. A Converter</div>
            <div class="font-weight-bold orange--text text--darken-3 body-2">
              {{ items.length }}
            </div>
          </v-col>
          <v-col cols="6" class="text-center border-left">
            <div class="caption grey--text text--darken-2">Total A Converter</div>
            <div class="font-weight-black green--text text--darken-3 body-2">
              {{ formatarValor(totalValor) }}
            </div>
          </v-col>
        </v-row>
        <v-row v-else no-gutters justify="space-between" align="center">
          <v-col cols="6" class="text-center">
            <div class="caption grey--text text--darken-2">Qtd. Orçamentos</div>
            <div class="font-weight-bold amber--text text--darken-3 body-2">
              {{ items.length }}
            </div>
          </v-col>
          <v-col cols="6" class="text-center border-left">
            <div class="caption grey--text text--darken-2">Total Geral</div>
            <div class="font-weight-black green--text text--darken-3 body-2">
              {{ formatarValor(totalValor) }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import db from '@/plugins/dexie';

export default {
  name: 'TabelaOrcamento',

  components: {
    simplebar,
  },

  data() {
    return {
      loading: false,
      items: [],
      idVendedor: 0,
      periodoFormatado: '',
    };
  },

  computed: {
    tipoFiltro() {
      return this.$route.query.tipo || '';
    },

    tituloTabela() {
      if (this.tipoFiltro === 'convertidos') return 'Tabela de Orçamentos Convertidos';
      if (this.tipoFiltro === 'a-converter') return 'Tabela de Orçamentos a Converter';
      return 'Tabela de Orçamentos';
    },

    totalValor() {
      return this.items.reduce((acc, item) => acc + (parseFloat(item.valor) || 0), 0);
    },
    
    totalConvertidos() {
      return this.items
        .filter(item => item.convertido)
        .reduce((acc, item) => acc + (parseFloat(item.valor) || 0), 0);
    },
    
    totalAConverter() {
      return this.items
        .filter(item => !item.convertido)
        .reduce((acc, item) => acc + (parseFloat(item.valor) || 0), 0);
    },
  },
  
  created() {
    this.carregarOrcamentos();
  },

  methods: {
    formatarValor(valor) {
      if (valor === undefined || valor === null || isNaN(valor)) return '0,00';
      return Number(valor).toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    },

    formatarData(dataVal) {
      if (!dataVal) return '-';
      try {
        if (dataVal instanceof Date) {
          if (isNaN(dataVal.getTime())) return '-';
          return dataVal.toLocaleDateString('pt-BR');
        }
        const d = new Date(dataVal);
        if (!isNaN(d.getTime())) {
          return d.toLocaleDateString('pt-BR');
        }
        if (typeof dataVal === 'string' && dataVal.includes('-')) {
          const partes = dataVal.split('T')[0].split('-');
          if (partes.length === 3) {
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
          }
        }
        return String(dataVal);
      } catch (e) {
        return String(dataVal);
      }
    },

    obterDateObjeto(dataVal) {
      if (!dataVal) return null;
      try {
        if (dataVal instanceof Date) {
          return isNaN(dataVal.getTime()) ? null : dataVal;
        }
        if (typeof dataVal === 'string') {
          if (dataVal.includes('/')) {
            const partes = dataVal.split(' ');
            const partesData = partes[0].split('/');
            if (partesData.length === 3) {
              const dataFormatada = `${partesData[2]}-${partesData[1].padStart(2, '0')}-${partesData[0].padStart(2, '0')}`;
              const horaFormatada = partes[1] || '00:00:00';
              const d = new Date(`${dataFormatada}T${horaFormatada}`);
              if (!isNaN(d.getTime())) return d;
            }
          }
          let str = dataVal;
          if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
            str += 'T00:00:00';
          }
          const d = new Date(str);
          if (!isNaN(d.getTime())) return d;
        }
        const d = new Date(dataVal);
        return isNaN(d.getTime()) ? null : d;
      } catch (e) {
        return null;
      }
    },

    async carregarOrcamentos() {
      this.loading = true;
      this.items = [];

      try {
        const parametro = await db.parametro.toCollection().first();
        
        const idVendedorLogado = parametro && parametro.idvendedorlogado 
          ? parseInt(parametro.idvendedorlogado, 10) 
          : 0;
          
        if (idVendedorLogado === 0) {
          console.warn("Nenhum vendedor logado encontrado na tabela de parâmetros.");
          this.loading = false;
          return; 
        }
        this.idVendedor = idVendedorLogado;

        let idEmpresaLogada = 1;
        const registroEmpresa = await db.empresa.limit(1).first();
        if (registroEmpresa && (registroEmpresa.idEmpresa || registroEmpresa.idempresa)) {
          idEmpresaLogada = Number(registroEmpresa.idEmpresa || registroEmpresa.idempresa);
        } else if (parametro && parametro.empresa) {
          idEmpresaLogada = parseInt(parametro.empresa, 10) || 1;
        }

        let inicioPeriodo, fimPeriodo;
        const paramInicio = this.$route.query['created-from'] || this.$route.query['createdFrom'];
        const paramFim = this.$route.query['created-before'] || this.$route.query['createdBefore'];

        if (paramInicio && paramFim) {
          const [anoIni, mesIni, diaIni] = paramInicio.split('-');
          inicioPeriodo = new Date(anoIni, mesIni - 1, diaIni, 0, 0, 0);

          const [anoFim, mesFim, diaFim] = paramFim.split('-');
          fimPeriodo = new Date(anoFim, mesFim - 1, diaFim, 23, 59, 59);
        } else if (paramInicio) {
          const [anoIni, mesIni, diaIni] = paramInicio.split('-');
          inicioPeriodo = new Date(anoIni, mesIni - 1, diaIni, 0, 0, 0);
          fimPeriodo = new Date(anoIni, mesIni - 1, diaIni, 23, 59, 59);
        } else {
          const agora = new Date();
          inicioPeriodo = new Date(agora.getFullYear(), agora.getMonth(), 1, 0, 0, 0);
          fimPeriodo = new Date(agora.getFullYear(), agora.getMonth() + 1, 0, 23, 59, 59);
        }

        const optData = { day: '2-digit', month: '2-digit', year: 'numeric' };
        this.periodoFormatado = `${inicioPeriodo.toLocaleDateString('pt-BR', optData)} até ${fimPeriodo.toLocaleDateString('pt-BR', optData)}`;

        const inicioTime = inicioPeriodo.getTime();
        const fimTime = fimPeriodo.getTime();

        const todosPedidos = await db.pedido
          .where('idvendedor')
          .equals(Number(idVendedorLogado))
          .toArray();

        const orcamentosFiltrados = todosPedidos.filter(p => {
          const temIdOrcamento = p.idorcamentoback !== null && p.idorcamentoback !== undefined && p.idorcamentoback !== '';
          const temIdPedido = p.idpedidoback !== null && p.idpedidoback !== undefined && p.idpedidoback !== '';
          const ehOrcamento = p.orcamento == 1 || p.orcamento === '1' || temIdOrcamento;

          if (!ehOrcamento) return false;

          const isConvertido = temIdOrcamento && temIdPedido;

          const ehConvertidos = this.tipoFiltro === 'convertidos';
          const ehAConverter = this.tipoFiltro === 'a-converter';

          if (ehConvertidos && !isConvertido) return false;
          if (ehAConverter && isConvertido) return false;

          const campoData = (ehConvertidos && p.dataconversao) ? p.dataconversao : p.data;
          const dtObj = this.obterDateObjeto(campoData);
          if (!dtObj) return false;
          
          const time = dtObj.getTime();
          const noPeriodo = time >= inicioTime && time <= fimTime;
          const pertenceAEmpresa = !p.idempresa || Number(p.idempresa) === Number(idEmpresaLogada);
          const naoCancelado = !p.datacancelamento && p.cancelado !== 'S';
          const naoLimpo = !p.datalimpeza;

          return noPeriodo && pertenceAEmpresa && naoCancelado && naoLimpo;
        });

        if (orcamentosFiltrados.length === 0) {
          this.loading = false;
          return;
        }

        const idsClientes = [...new Set(orcamentosFiltrados.map(p => Number(p.idcliente)).filter(Boolean))];
        const clientes = await db.cliente.where('idcliente').anyOf(idsClientes).toArray();
        const mapaClientes = {};
        clientes.forEach(c => {
          mapaClientes[Number(c.idcliente)] = c.nome || c.nomefantasia || '';
        });

        this.items = orcamentosFiltrados.map(p => {
          const dtObj = this.obterDateObjeto(p.data);
          const idCli = Number(p.idcliente);
          const nomeCli = mapaClientes[idCli] || p.clinome || `Cliente (${p.idcliente || '-'})`;
          const numOrcamento = p.idorcamentoback || p.idpedido || p.numero || '-';

          let valorFinal = 0;
          if (p.total !== undefined && p.total !== null && p.total !== '') {
            const totalStr = String(p.total).replace(',', '.');
            valorFinal = parseFloat(totalStr) || 0;
          }

          const isConvertido = (p.dataconversao !== null && p.dataconversao !== undefined && p.dataconversao !== '') ||
                               (p.idpedidoback !== null && p.idpedidoback !== undefined && p.idpedidoback !== '');

          return {
            id: p.idpedido || p.id,
            idorcamentoback: p.idorcamentoback,
            idpedidoback: p.idpedidoback,
            numeroOrcamento: numOrcamento,
            idCliente: idCli,
            nomeCliente: nomeCli,
            data: dtObj || p.data,
            dataObjeto: dtObj,
            dataconversao: p.dataconversao,
            valor: valorFinal,
            convertido: isConvertido
          };
        });

        this.items.sort((a, b) => {
          const dtA = a.dataObjeto ? a.dataObjeto.getTime() : 0;
          const dtB = b.dataObjeto ? b.dataObjeto.getTime() : 0;
          if (dtB !== dtA) {
            return dtB - dtA;
          }
          return (b.id || 0) - (a.id || 0);
        });

      } catch (error) {
        console.error("Erro ao carregar orçamentos:", error);
      } finally {
        this.loading = false;
      }
    }
  },

  watch: {
    '$route.query': {
      deep: true,
      handler() {
        this.carregarOrcamentos();
      },
    },
  },
};
</script>

<style scoped>
.view-wrapper {
  height: calc(100vh - 100px);
  background-color: white;
}

.table-custom {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  min-width: 480px;
}

.table-custom.tabela-convertidos {
  min-width: 580px;
}

.table-header th {
  background-color: #f5f5f5;
  color: #616161;
  padding: 10px 6px;
  font-size: 0.75rem;
  text-transform: uppercase;
  border-bottom: 2px solid #e0e0e0;
  white-space: nowrap;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 2;
  box-shadow: 0 2px 2px -1px rgba(0,0,0,0.1);
}

.table-row td {
  padding: 8px 6px;
  border-bottom: 1px solid #eeeeee;
  font-size: 0.85rem;
  color: #424242;
  white-space: nowrap;
}

.linha-alternada {
  background-color: #fafafa;
}

.border-left {
  border-left: 1px solid #e0e0e0;
}
.border-right {
  border-right: 1px solid #e0e0e0;
}

/* Configuração do Simplebar para scroll horizontal */
.table-scroll-container {
  overflow-x: auto;
}

.table-scroll-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(255, 160, 0, 0.5) !important;
}
</style>